import { render } from "./CategoryDetail.vue?vue&type=template&id=c6401de4"
import script from "./CategoryDetail.vue?vue&type=script&lang=js"
export * from "./CategoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__